import { appConstants } from '../../../constants'

const initialState = {
  articleCategory: [],
  loading: false,
  error: null
}

export const reducerArticleCategory = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.GET_ARTICLE_CATEGORY_SUCCESS :
      return {
        ...state,
        loading: false,
        error: null,
        articleCategory: [...action.payload.articleCategory]
      }
    case appConstants.GET_ARTICLE_CATEGORY_REQUEST :
      return {
        ...state,
        loading: !state.loading
      }
    case appConstants.GET_ARTICLE_CATEGORY_FAILED :
      return {
        ...state,
        error: { ...action.payload.message }
      }
    default:
      return state
  }
}
